import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  settings : null,
  checkrLogs : null,
  error : null
};

export const SETTINGS_URL = "admin/settings";
export const CHECKR_LOGS_URL = "admin/get/checkrlogs";
export const CHECKR_LOGS_URL_BY_USER_ID = "admin/get/checkrlogsById";

export const createOrUpdateSettings = createAsyncThunk(
  SETTINGS_URL,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(SETTINGS_URL, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getSettings = createAsyncThunk(
    SETTINGS_URL + '/get',
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(SETTINGS_URL);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        console.log(error)
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getCheckrLogs = createAsyncThunk(
  CHECKR_LOGS_URL,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(CHECKR_LOGS_URL, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getCheckrLogsByUserId = createAsyncThunk(
  CHECKR_LOGS_URL_BY_USER_ID,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      let id = formData.id
      const response = await axiosInstance.get(CHECKR_LOGS_URL_BY_USER_ID + "/" + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(createOrUpdateSettings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createOrUpdateSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settings = action.payload;
      })
      .addCase(createOrUpdateSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getSettings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settings = action.payload;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getCheckrLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCheckrLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.checkrLogs = action.payload;
      })
      .addCase(getCheckrLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logout, () => initialState);
  },
});

export default settingsSlice.reducer;